<template>
  <v-dialog v-model="show" max-width="700px">
    <v-card>
        <v-card color="#FFD375" class="elevation-12">
            <v-toolbar color="#FFA500">

                <div style="position:absolute; top:8px; left:17px; width:80px;" class="boldtext">Payment</div>

            </v-toolbar>

            <v-card class="pa-0 ma-0" flat style="width: 100%; height:200px;" tile>

                <div style="position:absolute; top:80px; left:30px; width:300px;" class="boldtext">Here we arrange payment...</div>

            </v-card>

            <v-card-actions>
                <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="#FFA500" @click="submit" data-cy="joinSubmitBtn">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-card>

  </v-dialog>
</template>

<script>

import firebase from 'firebase';

export default {
  props: {
     value: Boolean,
     selectedplan: Object
        },
    components: {
    },
  data() {
      return {
      };
  },
  computed: {
    show: {
      get () {
        this.plan = this.selectedplan;
        this.initialiseData();
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    } 
  },
  methods: {
      initialiseData() {
      },
      cancel(){
          this.show=false;
      },
      submit() {
          this.show = false;
          this.$store.state.paymentconfirmed = true;
      }
  }
}
</script>

<style scoped>
    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .subtext {
        color: black;
        font-size:small;
    }

    .normaltext {
        color: black;
    }

    .row-pointer > tbody tr :hover {
        cursor: pointer;
    }

</style>